<template>
  <div class="cmp-distribution-accounts-import-setup-modal2">
    <div class="contact-search">
      <InputField
        :value="searchString"
        :placeholder="'Search'"
        :config="{
          borderStyle: 'around',
          maxWidth: '330px',
        }"
        @keyup="onSearchInputKeyup"
      >
      </InputField>
    </div>

    <table
      style="
        margin-top: 20px;
      "
      class="dt-table2"
    >
      <thead
        class="dt-table2--head"
      >
        <tr
          class="dt-table2--row"
          :style="{
            'margin-right': hRowMarginRight,
          }"
        >
          <th class="dt-table2--column">{{ $t("contact") }}</th>

          <th class="dt-table2--column" style="border-right: 0px">
            {{ $dft.capHead($t("city")) }}
          </th>
        </tr>
      </thead>
      <tbody style="border: 1px solid var(--sprt-5);" class="dt-table2--body" @scroll="onScroll">
        <tr
          class="dt-table2--row"
          style="margin: 0px 10px; padding: 0px 15px"
          v-for="item in contactArray"
          :key="item.contact_id"
        >
          <td @click="onRowClicked(item)" class="dt-table2--column">
            <template v-if="item['company_name']">
              {{ item["company_name"] }}
            </template>
            <template v-else>
              {{ `${item["first_name"]} ${item["last_name"]}` }}
            </template>
          </td>
          <td class="dt-table2--column" style="border-right: 0px">
            {{ item["city"] }}
          </td>
        </tr>
      </tbody>
    </table>

    <div
      v-if="this.contact_id_invoice!=0"
      class="select-cont"
      style="margin-top: 20px;border: 1px solid var(--sprt-7); background: white"
    > 
      <h4 style="padding: 5px; background: var(--col-d5); color: white">
        Selected Contact
      </h4>

      <div v-if="selectedContact !== null">
        <p style="border-top: 1px solid var(--sprt-7)">
          {{ selectedContact["address1"] }}
        </p>
        <p>{{ selectedContact["city"] }}</p>
        <p>{{ selectedContact["postalcode"] }}</p>
        <p style="border-bottom: 0px">{{ selectedContact["country"] }}</p>
      </div>
      <p v-else>Select A Contact</p>
    </div>
  </div>
</template>

<script>
import { DTIconButton } from "../../../../plugins/button/button";
import NTable from "../../../../plugins/datatable/datatable";

import InputField from "@plugins/text-field/input-field";
import { DistributionStatementService } from "../../services/statement.service";

import { Subject } from "rxjs";

import { waitForAnimation, subscribeSubject } from "@/utility";
import { AccountService } from "../../services/account.service";

export default {
  props: {

     contact_id_invoice: {
      type: Number,
      default:0
    },
  },
  components: {
    NTable,
    InputField,
    DTIconButton,
    //AdvanceSearch,
  },
  mounted: async function () {



    const resd = await AccountService.stmtInvoiceContactList();

    if(this.$route.query.mode=='edit' && this.contact_id_invoice!=0){
      this.onRowClicked({contact_id:this.contact_id_invoice})
    }

    this.contactList = resd.data.contacts;

    subscribeSubject(this, this.contactSubject$, (searchString) => {
      AccountService.searchStmtInvoiceContactList(searchString).then((res) => {
        this.contactSearchResult = res.data.contacts;
      });
    });

    subscribeSubject(this, this.scrollSubject$, (scroll) => {
      this.currentRow += this.rowSize;

      AccountService.stmtInvoiceContactList(this.currentRow).then((res) => {
        this.contactList = [...this.contactList, ...res.data.contacts];
      });
    });
  },
  data: function () {
    return {
      searchString: "",
      contactSubject$: new Subject(),
      scrollSubject$: new Subject(),
      contactSearchResult: [],
      contactList: [],
      rowSize: 100,

      currentRow: 0,

      selectedContact: null,
    };
  },
  mixins: [],

  computed: {
    statement_line_id: function () {
      return this.$route?.query?.statement_line_id || "";
    },

    contactArray: function () {
      if (this.searchString.length > 0) {
        return this.contactSearchResult;
      } else {
        return this.contactList;
      }
    },

    hRowMarginRight: function () {
      if (this.contactList.length > 380 / 28) {
        return "28px";
      }
    },
  },
  methods: {
    onCancelClick: function () {
      this.$emit("cancelled", true);
    },
    onSearchInputKeyup: function (e) {
      this.searchString = e.target.value;
      this.contactSubject$.next(this.searchString);
    },
    onRowClicked: async function (item) {
      console.log(item);

      const res = await AccountService.getContact(item.contact_id);

      this.selectedContact = res.data.contact;

      this.$emit("selected", this.selectedContact);

      console.log(this.selectedContact, ":::::::::::::::");
    },
    onScroll: function (event) {
      this.scrollSubject$.next(event.target.scrollTop);
    },
  },
};
</script>

<style lang="scss">
.cmp-distribution-accounts-import-setup-modal2 {
  thead {
    .dt-table2--row {
      .dt-table2--column {
        margin-left: 10px;
      }
    }
  }
  tbody {
    .dt-table2--row {
      .dt-table2--column {
        // border-right: 1px solid var(--sprt-7);
        // margin-left: 10px;
        // padding: 10px 0px;
        cursor: pointer;
      }
    }
  }
  .select-cont {
    border-radius: 3px;
    p {
      margin-bottom: 0px;
     // border-bottom: 1px solid var(--sprt-7);
      padding: 5px;
    }
  }
}
</style>